import { Box, Typography } from '@mui/material';
import { useConfig } from '../../api/api';
import { numberToString } from '../special/numberConverter';
import { round } from '../special/round';

const MoneyLabel = ({
  money,
  symbolKey = 'currencySymbol',
  variant = 'body',
  props = {},
}) => {
  const config = useConfig();
  return (
    <Typography
      {...props}
      variant={variant}
      className="monospace whitespace-nowrap"
    >{`${numberToString(round(money))} ${
      config !== null ? config.currency[symbolKey] : ''
    }`}</Typography>
  );
};

export default MoneyLabel;
